(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-custom"] && !Shopify.designMode) return;
  try {
    
          $(document).ready(function(){
                $('.featured-collections').slick({
                dots: false,
                nextArrow: "<button class='slick-custom-button slick-arrow' aria-label='Next' type='button' style='position:relative; border:none;'><i class='fa fa-chevron-right'></i></button>",
                prevArrow: "<button class='slick-custom-button slick-arrow' aria-label='Previous' type='button' style='position:relative; border:none;'><i class='fa fa-chevron-left'></i></button>",
                appendArrows: '.nav-container',
                infinite: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 6,
                responsive: [
                    { 
                    breakpoint: 1026,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: true
                    } 
                    },
                    {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                    },
                    {
                    breakpoint: 481,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                    }
                ]
                });
            });

  } catch(e) { console.error(e); }
})();
})();
